//
//
//
//
//
//

export default {
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/tip/index.vue